import React, { FC } from "react";
import { useTypedSelector } from "../reducers";

const NcdcCatalogContent: FC = () => {
    const { site } = useTypedSelector(state => state.profile);
    return (
      <></>
    );
}

export default NcdcCatalogContent;
